const services = [
  {
    key: "unlimitedDistance",
    id: "unlimitedDistance",
    description: "Rajattomat kilometrit",
    category: "distance",
    isDefault: true,
  },
  {
    key: "handTruck",
    id: "handTruck",
    description: "Nokkakärryt",
    category: "normal",
    isDefault: true,
  },
  {
    key: "pet",
    id: "pet",
    description: "Lemmikkimaksu",
    category: "normal",
    isDefault: true,
  },
  {
    key: "exportLicense",
    id: "exportLicense",
    description: "Maastapoistumislupa",
    category: "normal",
    isDefault: true,
    enableTextInput: true,
    inputLabel: "Kohdemaa",
  },
  {
    key: "halvedDeductible",
    id: "halvedDeductible",
    description: "Omavastuu puolitettu",
    category: "deductible",
    isDefault: true,
  },
  {
    key: "noDeductible",
    id: "noDeductible",
    description: "Ei omavastuuta",
    category: "deductible",
    isDefault: true,
  },
];

export default services;
